import { StatusBadge } from "@/components/status-badge";
import type { StatusBadgeTone, StatusKey } from "@/components/status-badge";

const comparisonStatusConfig: Record<
  string,
  { status: StatusKey; label: string; tone?: StatusBadgeTone; showSpinner?: boolean }
> = {
  extracting: { status: "pending", label: "Extracting", showSpinner: true },
  processing: { status: "processing", label: "Processing", showSpinner: true },
  completed: { status: "completed", label: "Completed", showSpinner: false },
  failed: { status: "error", label: "Failed", showSpinner: false },
  undefined: { status: "pending", label: "Unknown", tone: "muted", showSpinner: false },
};

export function ComparisonStatusBadge({
  status,
  className,
}: {
  /** Convex/API values; known keys map via config, anything else falls back to Unknown */
  status: string | undefined | null;
  className?: string;
}) {
  const config =
    comparisonStatusConfig[String(status)] ?? comparisonStatusConfig.undefined;

  return (
    <StatusBadge
      status={config.status}
      label={config.label}
      tone={config.tone}
      showSpinner={config.showSpinner}
      className={className}
    />
  );
}
